import { http } from 'services';

export function getPersons(type, params, cbSuccess, cbError) {
  http.get(
    type,
    params,
    (persons) => {
      console.log('getPersons', persons);
      cbSuccess(persons.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonDetails(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}`,
    null,
    (personDetails) => {
      cbSuccess(personDetails.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deletePerson(type, id, params, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}`,
    params,
    (personDetails) => {
      cbSuccess(personDetails.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonLifeStages(type, cbSuccess, cbError) {
  http.get(
    `${type}/life-stages`,
    null,
    (lifeStages) => {
      cbSuccess(lifeStages.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function addPerson(type, payload, cbSuccess, cbError) {
  http.post(
    type,
    payload,
    (personDetails) => {
      cbSuccess(personDetails.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function savePersonDetails(type, id, payload, cbSuccess, cbError) {
  http.patch(
    `${type}/${id}`,
    payload,
    (personDetails) => {
      cbSuccess(personDetails.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function savePersonProfilePicture(type, id, file, cbSuccess, cbError) {
  const { FormData } = window;
  const form = new FormData();
  form.append('profile_picture', file);
  http.post(
    `${type}/${id}/profile-picture`,
    form,
    (profilePicture) => {
      cbSuccess(profilePicture.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// start ~ person programs
export function getPersonPrograms(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/programs`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function createPersonProgram(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/programs`,
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}
// end ~ person programs

// start ~ Person Health Category
export function getPersonCategory(type, id, code, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/categories/${code}`,
    {},
    (persons) => {
      cbSuccess(persons.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function savePersonCategory(type, id, code, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/categories/${code}`,
    payload,
    (persons) => {
      cbSuccess(persons.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// start ~ PERSON MEASUREMENTS
export function getPersonSettingsMeasurementGeneral(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/settings/measurement/general`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function savePersonSettingsMeasurementGeneral(type, id, payload, cbSuccess, cbError) {
  http.put(
    `${type}/${id}/settings/measurement/general`,
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonSettingsTrackedMeasurements(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/settings/measurement/tracked-measurements`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function savePersonSettingsTrackedMeasurements(type, id, payload, cbSuccess, cbError) {
  http.put(
    `${type}/${id}/settings/measurement/tracked-measurements`,
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonMeasurements(type, id, query, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/measurements`,
    query,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonMeasurementTypes(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/measurement-types`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonMeasurement(type, id, measurementID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/measurements/${measurementID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getPersonOccupiedDates(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/occupied-dates`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function addPersonMeasurement(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/measurements`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function editPersonMeasurement(type, id, measurementID, payload, cbSuccess, cbError) {
  http.patch(
    `${type}/${id}/measurements/${measurementID}`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function deletePersonMeasurement(type, id, measurementID, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}/measurements/${measurementID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}
// end ~ PERSON MEASUREMENTS

export function assignProgram(type, id, payload, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/assign-program`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function removeProfilePicture(type, id, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}/profile-picture`,
    {},
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function sendAccountActivationToken(type, id, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/send-account-activation-token`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function setPersonStatus(type, id, payload, cbSuccess, cbError) {
  http.put(
    `${type}/${id}/status`,
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-persons/api-persons-base.js